import React, { useState, useEffect } from 'react';
import './ProductList.css'; // Archivo CSS para estilos
import axios from 'axios'; // Para enviar datos a la base de datos

const ProductVoting = () => {
    const [products, setProducts] = useState([]);
    const [filteredProducts, setFilteredProducts] = useState([]);
    const [selectedProduct, setSelectedProduct] = useState(null);
    const [submitted, setSubmitted] = useState(false);
    const [userName, setUserName] = useState('');
    const [userSurname, setUserSurname] = useState('');
    const [userEmail, setUserEmail] = useState('');
    const [emailError, setEmailError] = useState('');
    const [showPopup, setShowPopup] = useState(true);

    const togglePopup = () => {
        setShowPopup(!showPopup);
    };

    useEffect(() => {
        axios.get('https://cradleevent.online/api.php?action=getProducts')
            .then(response => {
                const sortedProducts = response.data.sort((a, b) => {
                    if (a.cantidad === 0 && b.cantidad > 0) return 1;
                    if (a.cantidad > 0 && b.cantidad === 0) return -1;
                    return a.nombre.localeCompare(b.nombre);
                });
                setProducts(sortedProducts);
                setFilteredProducts(sortedProducts);
            })
            .catch(error => {
                console.error('Error al obtener los productos:', error);
            });
    }, []);

    const handleSelect = (product) => {
        if (product.cantidad > 0) {
            setSelectedProduct(product);
        }
    };

    const validateEmail = (email) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    };

    const validateName = (name) => {
        const nameRegex = /^[A-Za-zÁÉÍÓÚáéíóúÑñ]+$/;
        return nameRegex.test(name);
    };

    const handleSubmit = () => {
        if (selectedProduct && userName && userSurname && userEmail) {
            if (!validateName(userName) || !validateName(userSurname)) {
                setEmailError('El nombre y el apellido deben contener solo letras.');
                return;
            }
            if (!validateEmail(userEmail)) {
                setEmailError('Por favor, ingresa un correo electrónico válido.');
                return;
            }
            setEmailError('');
            axios.post('https://cradleevent.online/api.php?action=vote', {
                productName: selectedProduct.nombre,
                userName,
                userSurname,
                userEmail
            })
            .then(() => {
                setSubmitted(true);
                setProducts(products.map(product =>
                    product.nombre === selectedProduct.nombre
                        ? { ...product, cantidad: product.cantidad - 1 }
                        : product
                ));
                setFilteredProducts(filteredProducts.map(product =>
                    product.nombre === selectedProduct.nombre
                        ? { ...product, cantidad: product.cantidad - 1 }
                        : product
                ));
            })
            .catch((error) => {
                console.error('Error al enviar el regalo:', error);
            });
        } else {
            const missingFields = [];
            if (!userName) {
                missingFields.push('Nombre');
            }
            if (!userSurname) {
                missingFields.push('Apellido');
            }
            if (!userEmail) {
                missingFields.push('Correo electrónico');
            }
            setEmailError(`Por favor, completa los siguientes campos: ${missingFields.join(', ')}.`);
        }
    };

    const handleSort = (type) => {
        let sortedArray = [];
        if (type === 'alphabetical') {
            sortedArray = [...filteredProducts].sort((a, b) => a.nombre.localeCompare(b.nombre));
        } else if (type === 'quantity') {
            sortedArray = [...filteredProducts].sort((a, b) => b.cantidad - a.cantidad);
        }
        setFilteredProducts(sortedArray);
    };

    return (
        <div className="product-voting-container">
            <button className="floating-btn" onClick={togglePopup} style={{ position: 'fixed', bottom: '20px', right: '20px', zIndex: 1000, width: '40px', height: '40px', borderRadius: '50%', backgroundColor: 'white', border: 'none', boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)', cursor: 'pointer', fontSize: '1.5rem' }}>
                <span role="img" aria-label="info">🔎</span>
            </button>

            {showPopup && (
                <div className="modal fade show d-block" id="participationModal" tabIndex="-1" role="dialog" aria-labelledby="modalLabel" aria-hidden="true">
                    <div className="modal-dialog modal-dialog-centered" role="document">
                        <div className="modal-content">
                            <div className="modal-header justify-content-center">
                                <h5 className="modal-title" id="modalLabel">Babyshower de Emma Isabella</h5>
                            </div>
                            <div className="modal-body">
                            <h5 className="modal-title" id="modalLabel">¿Cómo seleccionar regalo?</h5>
                                <ol>
                                    <li><b>Paso 1: </b>Dale click a ver detalle del regalo que más te guste. Te enviará a la página de compra.</li>
                                    <li><b>Paso 2: </b>En la página de Baby shower selecciona el regalo e ingresa tus nombres y correo. Dale Enviar.</li>
                                    <li><b>Paso 3: </b>Te llegará un correo de confirmación con el detalle del regalo escogido (Enlace de la página y nombre del regalo).</li>
                                    <li>¡Nos vemos, el 22 de Noviembre 👶!</li>
                                </ol>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="submit-button" onClick={togglePopup}>Cerrar</button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {!submitted && <h1>¡Haz que mi primer regalo sea inolvidable!</h1>}
            {!submitted && (
                <div className="user-input" style={{ marginBottom: '20px' }}>
                    <input
                        type="text"
                        placeholder="Nombre"
                        value={userName}
                        onChange={(e) => setUserName(e.target.value)}
                    />
                    <input
                        type="text"
                        placeholder="Apellido"
                        value={userSurname}
                        onChange={(e) => setUserSurname(e.target.value)}
                    />
                    <input
                        type="email"
                        placeholder="Correo electrónico"
                        value={userEmail}
                        onChange={(e) => setUserEmail(e.target.value)}
                    />
                    {emailError && <p className="error-message">{emailError}</p>}
                    {selectedProduct && selectedProduct.cantidad > 0 && (
                        <button onClick={handleSubmit} className="submit-button">Enviar</button>
                    )}
                </div>
            )}
            {!submitted && (
                <div className="filter-buttons" style={{ display: 'flex', justifyContent: 'center', gap: '10px', marginBottom: '20px' }}>
                    <button onClick={() => handleSort('alphabetical')} className="submit-button">Ordenar alfabéticamente</button>
                    <button onClick={() => handleSort('quantity')} className="submit-button">Ordenar por cantidad</button>
                </div>
            )}
            {!submitted ? (
                <div className="product-list">
                    {filteredProducts.map((product, index) => (
                        <div
                            key={index}
                            className={`product-item ${product === selectedProduct ? 'selected' : ''} ${product.cantidad === 0 ? 'blocked' : ''}`}
                            onClick={() => handleSelect(product)}
                            style={product.cantidad === "0" ? { pointerEvents: 'none', opacity: 0.5, backgroundColor: '#f8d7da' } : {}}
                        >
                            <h3 className='product-name'>{product.nombre}</h3>
                            <p className={`product-quantity ${product.cantidad === 0 ? 'out-of-stock' : ''}`}>
                                Cantidad disponible: {product.cantidad}
                            </p>
                            <a href={product.url} target="_blank" rel="noopener noreferrer">Ver detalle</a>
                        </div>
                    ))}
                </div>
            ) : (
                <div>
                    <p className='final'>Gracias por seleccionar tu regalo.</p>
                    <p className='final'>Se enviará el detalle del regalo seleccionado a tu correo.</p>
                    <button onClick={() => window.location.reload()} className="submit-button">Escoger otro regalo</button>
                </div>
            )}
            <footer style={{ marginTop: '20px', fontFamily: 'Delius, sans-serif', fontWeight: 'bold', color: '#5c5c5c' }}>
                <p className='author-text'>Hecho con 🩷 por Equipo Cradle Event</p>
            </footer>
        </div>
    );
};

export default ProductVoting;
